import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IndentedCard, Skeleton } from 'js/components/design-system';

const LawyerSummarySkeleton = (props) => {
  const { className, animated } = props;
  return (
    <Skeleton
      className={classnames('lawyer-summary-skeleton', className)}
      animated={animated}
    >
      <IndentedCard>
        <div className="skeleton-row">
          <div className="skeleton-column">
            <div className="skeleton-bone" />
          </div>
          <div className="skeleton-column" />
          <div className="skeleton-column" />
          <div className="skeleton-column" />
        </div>
        <div className="skeleton-row">
          <div className="skeleton-column">
            <div className="skeleton-bone" />
          </div>
          <div className="skeleton-column" />
        </div>
        <div className="skeleton-row">
          <div className="skeleton-column">
            <div className="skeleton-bone" />
          </div>
          <div className="skeleton-column">
            <div className="skeleton-bone" />
          </div>
          <div className="skeleton-column">
            <div className="skeleton-bone" />
          </div>
          <div className="skeleton-column" />
        </div>
      </IndentedCard>
    </Skeleton>
  );
};

LawyerSummarySkeleton.defaultProps = {
  animated: false,
};

LawyerSummarySkeleton.propTypes = {
  className: PropTypes.string,
  animated: PropTypes.bool,
};

export default LawyerSummarySkeleton;
